(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@uirouter/angularjs"), require("angular-animate"), require("angular-ui-bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define("guanlecoja-ui", ["@uirouter/angularjs", "angular-animate", "angular-ui-bootstrap"], factory);
	else if(typeof exports === 'object')
		exports["guanlecoja-ui"] = factory(require("@uirouter/angularjs"), require("angular-animate"), require("angular-ui-bootstrap"));
	else
		root["guanlecoja-ui"] = factory(root["@uirouter/angularjs"], root["angular-animate"], root["angular-ui-bootstrap"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__uirouter_angularjs__, __WEBPACK_EXTERNAL_MODULE_angular_animate__, __WEBPACK_EXTERNAL_MODULE_angular_ui_bootstrap__) {
return 